module.exports = __webpack_public_path__ + "img/course-cari.02dc4986.jpg";